import { Button, message, Space, Table, Select } from "antd";
import { useEffect, useState, useCallback } from "react";
import { serverFetch } from "../../server";
import { renderCheckbox } from "../../extensions/helper";
import SettingsProgPrice from "./settings-prog-price";

const SettingsProgPrices = ({ progId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [licenses, setLicenses] = useState([]);
  const [selectedLicenseId, setSelectedLicenseId] = useState(null);

  const getData = useCallback(() => {
    console.log('getData called with:', { progId, selectedLicenseId });
    if (!progId || !selectedLicenseId) return;
    setLoading(true);
    serverFetch(`dict/price?progId=${progId}&licId=${selectedLicenseId}`)
      .then((data) => {
        console.log('Prices loaded:', data);
        setItems(data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }, [progId, selectedLicenseId]);

  const getLicenses = useCallback(() => {
    if (!progId) return;
    serverFetch(`dict/license?idProg=${progId}`)
      .then((data) => {
        setLicenses(data);
        // Автоматически выбираем первую лицензию, если есть
        if (data.length > 0 && !selectedLicenseId) {
          setSelectedLicenseId(data[0].idLic);
        }
      })
      .catch((e) => {
        message.error(e.userMessage);
      });
  }, [progId, selectedLicenseId]);

  useEffect(() => {
    if (progId) {
      getLicenses();
    }
  }, [progId, getLicenses]);

  useEffect(() => {
    if (progId && selectedLicenseId) getData();
  }, [progId, selectedLicenseId, getData]);

  const handleAdd = () => {
    setSelectedPrice({ priceId: null, progId: progId, licId: selectedLicenseId });
  };

  const handleEdit = (record) => {
    setSelectedPrice({ priceId: record.id, progId: progId, licId: selectedLicenseId });
  };

  const handleLicenseChange = (value) => {
    console.log('Changing license to:', value);
    setSelectedLicenseId(value);
  };

  const handlePriceClose = (refresh) => {
    setSelectedPrice(null);
    if (refresh) {
      getData();
    }
  };

  const columns = [
    { dataIndex: "id", title: "#", width: 60 },
    { dataIndex: "active", title: "Активно", width: 80, render: renderCheckbox },
    { dataIndex: "name", title: "Наименование", width: 200 },
    { dataIndex: "qtyMin", title: "Кол. мин.", width: 100 },
    { dataIndex: "qtyMax", title: "Кол. макс.", width: 100 },
    { dataIndex: "duration", title: "Срок, дней", width: 120 },
    { dataIndex: "comment", title: "Комментарий", width: 200 },
    { dataIndex: "price", title: "Цена", width: 120 },
  ];

  return (
    <div style={{ maxWidth: "90%" }}>
      <Space style={{ marginBottom: 16 }}>
        <Select
          placeholder="Выберите вид лицензии"
          value={selectedLicenseId}
          onChange={handleLicenseChange}
          style={{ width: 200 }}
          options={licenses.map(license => ({
            value: license.idLic,
            label: license.name
          }))}
        />
        <Button type="primary" onClick={handleAdd}>Добавить</Button>
        <Button onClick={getData} loading={loading}>Обновить</Button>
      </Space>
      <Table
        columns={columns}
        dataSource={items}
        loading={loading}
        rowKey="id"
        pagination={false}
        size="small"
        onRow={(record) => ({
          onClick: () => handleEdit(record),
          style: { cursor: 'pointer' }
        })}
      />

      {selectedPrice && (
        <SettingsProgPrice
          progId={selectedPrice.progId}
          priceId={selectedPrice.priceId}
          licId={selectedPrice.licId}
          onClose={handlePriceClose}
        />
      )}
    </div>
  );
};

export default SettingsProgPrices;
